import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const defaultEN = {
  first_name: "first name",
  last_name: "last name",
  middle_name: "middle name",
  greet_meet: "Greet and Meet",
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: defaultEN, // ✅ preload English translations
      },
    },
    lng :"en",
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
